module.exports = __webpack_public_path__ + "img/116.9.f72c558b.png";